<template>
  <div>
    <router-link class="btn btn-primary btn-lg btn-vote" :to="{ name: 'liste', params: {type: 'liste'}}" title="Aktuelle Abstimmungen">VOTE!</router-link>
    <b-carousel class="carousel"
      :interval="3000"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
    >
      <b-carousel-slide img-src="https://picsum.photos/id/330/1500/450">
        <h3>Annahme des Protokolls der GV 2019</h3>
      </b-carousel-slide>

      <b-carousel-slide img-src="https://picsum.photos/id/335/1500/450">
        <h3>Wahl des Geschäftsführer</h3>
      </b-carousel-slide>

      <b-carousel-slide img-src="https://picsum.photos/id/337/1500/450">
        <h3>Neuwahlen in den Vorstand</h3>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>

export default {
  name: 'Carousel',
};

</script>
<style scoped>
  /* carousel */
  .carousel-inner{
    width:100%;
  }

  .carousel-item{
    max-height: 60vh;
  }

  .carousel{
    z-index: 1000;
  }

  .carousel img{
    min-height: 100% !important;
    min-width: 100%;
    position: relative;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .bildlink, .bildlink:active, .bildlink:hover{
    color: white;
  }

  .carousel h3{
    text-shadow: 0 0 20px black;
  }

  .btn-vote{
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
    border: rgb(228,23,23);
    background-color: rgb(228,23,23);
    z-index: 1001;
    position: absolute;
    left: 1em;
    top: 4em;
    width: 10em;
  }
  .btn-vote:hover{
    background-color: rgb(191, 19, 19);
  }
  .btn-vote:active,
  .btn-vote:focus{
    background-color: rgb(159, 16, 16) !important;
    box-shadow: 0 0 0 0.2rem rgba(159, 16, 1, 0.5) !important;
  }
</style>
